import { AttributeValue } from "../../../../library-js/dom-tools/AttributeValue";
import { ClassFlag } from "../../../../library-js/dom-tools/ClassFlag";
import { ElementAttribute } from "../../../../library-js/dom-tools/ElementAttribute";
import { ElementType } from "../../../../library-js/dom-tools/ElementType";
import { HTMLEditor } from "../../../../library-js/dom-tools/HTMLEditor";
import { RegExpUtility } from "../../../../library-js/text/RegExpUtility";
import { GodotDocsVersion } from "../../../js/godot-docs/GodotDocsVersion";
import { Rokojori } from "../../../js/Rokojori";
import { GodotNode } from "./GodotNode";

export class GodotSceneHierarchy
{
  static readonly type  = new ElementType( "godot-scene-hierarchy" );
  static readonly scroller = new ElementType( "godot-scene-hierarchy-scroller" );
  static readonly rootVisibility = new ElementAttribute( "root-visibility" );
  static readonly rootVisibilityHidden = new AttributeValue( GodotSceneHierarchy.rootVisibility, "hidden" );
  static readonly hideNodes = new ElementAttribute( "hide-nodes" );

  static applyOnDocument()
  {
    GodotSceneHierarchy.type.forAllInDoc( e => GodotSceneHierarchy.applyOnElement( e ) );
  }

  static applyOnElement( e:Element )
  {
    GodotDocsVersion.toNewest();

    let contentElement = e;
    let content = contentElement.innerHTML;

    let lines = RegExpUtility.splitLines( RegExpUtility.removeLeadingSpace( content ) );

    contentElement.innerHTML = "";


    let root = GodotNode.root();

    let currentParentNode = root;

    let nodes:GodotNode[] = [];

    lines.forEach(
      ( l )=>
      {
        if ( RegExpUtility.isEmptyString( l ) )
        {
          return;
        }        

        let node = GodotNode.create( l );

        // console.log( "[ " + node._type + " ] OFFSETS:", currentParentNode._offset, node._offset, "PARENT:", currentParentNode, "NODE:", node );

        while ( node._offset <= currentParentNode._offset )
        {
          currentParentNode = currentParentNode.parent;
          // console.log( "  << PARENT UP:", currentParentNode._offset, "PARENT:", currentParentNode );
        }
        
        while ( currentParentNode._offset - node._offset < -2 )
        {          
          currentParentNode = currentParentNode.children[ currentParentNode.children.length -1 ];
          // console.log( "  >> PARENT CHANGE:", currentParentNode._offset, "PARENT:", currentParentNode );
        }

        if ( currentParentNode._offset - node._offset == -2)
        {
          // console.log( "ADD CHILD:", node );
          currentParentNode.addChild( node );
        }

        contentElement.appendChild( node.element );  
        nodes.push( node );
      }
    );

    nodes.forEach( 
      ( n )=>
      {
        if ( n.children.length <= 0 )
        {
          return;
        }

        ClassFlag.open.set( n.element );

      }
    );

    if ( GodotSceneHierarchy.rootVisibilityHidden.in( e ) )
    { 
      root.children.forEach( c => c.setChildrenVisibility( false ) );
    }
    
    if ( GodotSceneHierarchy.hideNodes.in( e ) )
    {
      let nodeNames = GodotSceneHierarchy.hideNodes.from( e ).split( "," ).map( n => n.trim() );
      let nodeNamesMap = new Set<string>();
      nodeNames.forEach(
        ( n )=>
        {
          nodeNamesMap.add( n );
        }
      );

      let walker = GodotNode.walker;

      walker.forAll( root,
        ( c )=>
        {
          if ( nodeNamesMap.has( c.label ) )
          {
            c.setChildrenVisibility( false );
          }
        }
      );

    }




  }


}